const { isURL } = require('lib/validator')
const BaseModel = require('lib/base_model')

const App = BaseModel.extend({

    defaults: {
        platform: '',
        site_url: '',
    },

    validate(attrs) {
        if (! attrs.platform) {
            return 'Social platform is not found!'
        }

        if (! attrs.site_url) {
            return 'Please enter a URL for this app.'
        }

        if (! isURL(attrs.site_url)) {
            return 'That URL is invalid.'
        }
    },

})

module.exports = App
